enum WidgetType {
	ActionOnly = 'action_only',
	Rectangle = 'rectangle',
	Image = 'image',
	Button = 'button',
	Video = 'video',
	Chapter = 'chapter',
	Audio = 'audio',
	TextLabel = 'textLabel',
	App = 'app',
	FormTextField = 'formTextField',
	FormTextArea = 'formTextArea',
	FormSelect = 'formSelect',
	Timer = 'timer',
	Custom = 'custom',
	Group = 'group'
}

export { WidgetType };
